'use strict';

const validator = require('../../validator'),
    ritualsFormHelper = require('../../rituals-form-helper'),
    places = require('../../modules/google').places,
    getCountryFromLocaleCookie = require('../../modules/util/getCountryFromLocaleCookie');

function searchByPostalCode(e) {
    e.preventDefault();
    const $form = $(this);
    const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

    if ($postalCodeElement.val() === $form.data('current-postal-code')) {
        return;
    }

    if (!$form.valid()) {
        return;
    }

    hideTopError();

    const $buttonElement = $('.js-search-by-postalcode', $form);
    const $orderTotals = $form.parents('.js-order-totals');
    const $cartSubmitElement = $('.js-cart-action-checkout button');
    const pickupInStoreEnabled = $('.js-enabled-geolocation', $orderTotals).length;

    $buttonElement.addClass('btn--disabled').addClass('button-loading');
    $cartSubmitElement.addClass('btn--disabled');
    $('.js-postal-code-spinner', $buttonElement).addClass('spinner-visible');

    const ajaxOptions = {
        url: $form.attr('action'),
        data: $form.serialize() + '&' + $buttonElement.attr('name') + '=searchByPostalCode',
        type: 'POST',
        success: function (result) {
            $orderTotals.html(result);
            ritualsFormHelper.initializeDataMask('.js-order-totals');
            validator.init();
            //giftwrap.getGiftwrapDataForSelectedShippingOption(newSelectedShippingType, 'cart');
            handleExclusionResults();
        },
        error: function (xhr) {
            $buttonElement.removeClass('btn--disabled').removeClass('button-loading');
            $('.js-postal-code-spinner', $buttonElement).removeClass('spinner-visible');
            if (!xhr.status === 400) {
                return;
            }
            const response = xhr.responseJSON;
            showPostalError($postalCodeElement, response);
        },
        complete: function () {
            $cartSubmitElement.removeClass('btn--disabled');
        }
    };

    if (pickupInStoreEnabled) {
        places.getLatLongFromPostalCode($postalCodeElement.val(), getCountryFromLocaleCookie(), function (latitude, longitude) {
            ajaxOptions.data += '&latitude=' + latitude + '&longitude=' + longitude;
            $.ajax(ajaxOptions);
        });
        return;
    }

    $.ajax(ajaxOptions);
}

function showPostalError(postalCode, errors) {
    const formValidator = $('#postal-code-form').validate();
    $('#dwfrm_shippingpostalcode_postal-error').remove();
    formValidator.resetForm();
    const errorObj = {};
    errorObj[postalCode.attr('name')] = errors.PostalCodeError;
    formValidator.showErrors(errorObj);
}

function handleExclusionResults() {
    const $exclusionTextElement = $('#exclusionResults');

    if (!$exclusionTextElement.length) {
        handleTopError('');
        $('.js-exclusion-error:not(.js-totally)').remove();
        return;
    }

    const errors = JSON.parse($exclusionTextElement.val()) || {
        excludedProducts: {}
    };

    $('.js-cart-row[data-product-id]').each(function () {
        const productRow = $(this);
        const productId = productRow.data('product-id');
        const $existingError = $('.js-exclusion-error', productRow);
        if (!errors.excludedProducts[productId]) {
            $existingError.remove();
            return;
        }

        if ($existingError.hasClass('js-totally')) {
            return;
        }

        const $newError = $('<div>', {
            'class': 'inline-alert js-exclusion-error'
        });
        $newError.addClass(errors.excludedProducts[productId].type)
            .append('<span>' + errors.excludedProducts[productId].message + '</span>');

        if ($existingError.length) {
            $existingError.replaceWith($newError);
            return;
        }

        productRow.append($newError);

    });

    handleTopError(errors.errorMessage);
}

function editPostal(e) {
    $('#postal-code-form').addClass('active');
    $(e.target).addClass('hide');
}

function addPostal(e) {
    $('#postal-code-form').addClass('active');
    $(e.target).addClass('hide');
}

function handleTopError(errorMessage) {
    const $topError = $('.js-top-error');
    const valid = errorMessage == '' || $topError.hasClass('valid');
    $(document).off('click.postalCode', '.js-cart-action-checkout button');
    $topError.removeClass('valid');

    if (valid) {
        $topError.addClass('hide');
        $(window).off('scroll.toperror');
        return;
    }

    if (errorMessage) {
        $('p', $topError).text(errorMessage);
    }

    $(document).on('click.postalCode', '.js-cart-action-checkout button', function (e) {
        e.preventDefault();
        const $bannerPlaceholder = $('.error-banner-placeholder', $topError);
        $topError.removeClass('hide');
        checkTopPosition($bannerPlaceholder);
        addScrollEvent($bannerPlaceholder);
        removeSpinner($(this));
    });
}

function hideTopError() {
    $('.js-top-error:not(.hide)').addClass('hide');
}

function addScrollEvent(bannerPlaceholder) {
    $(window).on('scroll.toperror', function () {
        checkTopPosition(bannerPlaceholder);
    });
}

function checkTopPosition($bannerPlaceholder) {
    if ($bannerPlaceholder[0].getBoundingClientRect().top <= 0) {
        $bannerPlaceholder.next().addClass('fixed');
        return;
    }

    $bannerPlaceholder.next().removeClass('fixed');
}

function removeSpinner(button) {
    button.addClass('btn--disabled');
    const spinner = $('.js-spinner-general', button);

    if (spinner.length) {
        button.removeClass('button-loading');
        spinner.removeClass('spinner-visible');
    }
}

module.exports = {
    init: function () {
        if (!$('.checkout-v3').length) {
            return;
        }
        $(document).off('submit.postalCode', '#postal-code-form').on('submit.postalCode', '#postal-code-form', searchByPostalCode);
        $(document).off('click.postalCode', '.js-postal-form-trigger-add').on('click.postalCode', '.js-postal-form-trigger-add', addPostal);
        $(document).off('click.postalCode', '.js-postal-form-trigger-edit').on('click.postalCode', '.js-postal-form-trigger-edit', editPostal);
        handleTopError();
    }
};
